import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("selec_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Ocurrió un error. Intenta de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

function showPdfOverlay(url, filename) {
  const ov = document.createElement("div");
  ov.setAttribute("data-testid", "pdf-viewer-overlay");
  ov.style.cssText = "position:fixed;inset:0;z-index:99999;background:rgba(15,23,42,.9);display:flex;flex-direction:column;";
  const bar = document.createElement("div");
  bar.style.cssText = "display:flex;align-items:center;gap:8px;padding:10px 14px;padding-top:calc(env(safe-area-inset-top) + 10px);background:#0f172a;color:#fff;font-family:system-ui,-apple-system,sans-serif;";
  const title = document.createElement("span");
  title.textContent = filename || "Documento PDF";
  title.style.cssText = "flex:1;font-size:14px;font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;";
  const mkBtn = (label, primary) => {
    const b = document.createElement("button");
    b.textContent = label;
    b.style.cssText = `background:${primary ? "#2563eb" : "#1e293b"};color:#fff;border:0;border-radius:8px;padding:8px 14px;font-size:13px;font-weight:600;cursor:pointer;`;
    return b;
  };
  const printBtn = mkBtn("Imprimir", true);
  const dlBtn = mkBtn("Descargar");
  const closeBtn = mkBtn("✕ Cerrar");
  const frame = document.createElement("iframe");
  frame.src = url;
  frame.title = filename || "Documento PDF";
  frame.style.cssText = "flex:1;width:100%;border:0;background:#fff;";
  const cleanup = () => {
    document.removeEventListener("keydown", onKey);
    ov.remove();
    try { window.URL.revokeObjectURL(url); } catch (e) {}
  };
  const onKey = (e) => { if (e.key === "Escape") cleanup(); };
  closeBtn.onclick = cleanup;
  ov.addEventListener("click", (e) => { if (e.target === ov) cleanup(); });
  dlBtn.onclick = () => { const a = document.createElement("a"); a.href = url; a.download = filename || "documento.pdf"; document.body.appendChild(a); a.click(); a.remove(); };
  printBtn.onclick = () => { try { frame.contentWindow.focus(); frame.contentWindow.print(); } catch (e) {} };
  bar.append(title, printBtn, dlBtn, closeBtn);
  ov.append(bar, frame);
  document.body.appendChild(ov);
  document.addEventListener("keydown", onKey);
}

export async function openPdf(path, filename) {
  // En navegador se abre una pestaña nueva (dentro del gesto de clic para evitar el bloqueo de popups).
  const standalone = (window.matchMedia && window.matchMedia("(display-mode: standalone)").matches) || window.navigator.standalone === true;
  let win = null;
  if (!standalone) {
    try { win = window.open("", "_blank"); } catch (e) { win = null; }
  }
  try {
    const res = await api.get(path, { responseType: "blob" });
    const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
    if (win && !win.closed) {
      win.location = url;
      setTimeout(() => window.URL.revokeObjectURL(url), 60000);
    } else {
      // App instalada (PWA) o popup bloqueado: mostrar visor dentro de la app en vez de descargar directo.
      showPdfOverlay(url, filename);
    }
  } catch (e) {
    if (win && !win.closed) win.close();
    throw e;
  }
}

export async function downloadCsv(path, params, filename) {
  const res = await api.get(path, { params, responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data], { type: "text/csv;charset=utf-8" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || "export.csv";
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => window.URL.revokeObjectURL(url), 10000);
}

export function money(cur, n) {
  const v = Number(n || 0).toLocaleString("es-GT", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return (!cur || cur === "GTQ" || cur === "Q") ? `Q.${v}` : `${cur} ${v}`;
}

// Terminología unificada de presentación para ventas (no cambia el estado interno).
export function salesLabel(s) {
  return { Aprobada: "Ganada", Convertida: "Ganada", "Parcialmente convertida": "Parcialmente ganada" }[s] || s;
}

export function accountLabel(a) {
  if (!a) return "";
  let base = a.bank ? `${a.name} · ${a.bank}` : a.name;
  if (a.account_type) base += ` · ${a.account_type}`;
  return a.currency ? `${base} (${a.currency})` : base;
}

export function clientLabel(c) {
  if (!c) return "";
  const bn = (c.business_name || "").trim();
  const cn = (c.commercial_name || "").trim();
  return cn && cn.toLowerCase() !== bn.toLowerCase() ? `${bn} · ${cn}` : bn;
}

export default api;
